<nx-checkbox [(checked)]="promoCheckbox" (click)="promoCheckboxClicked()" class="nx-margin-bottom-s">
  {{ 'offer.discount.checkbox' | translate }}
</nx-checkbox>
<div *ngIf="promoCheckbox" class="promo-wrapper">
  <p nxCopytext="normal" class="promo-title">{{ 'offer.discount.title' | translate }}</p>
  <form [formGroup]="formGroup" class="promo-form">
    <nx-formfield [label]="'offer.discount.label' | translate" class="promo-formfield">
      <input
        required
        nxInput
        formControlName="discountCode"
        [maxlength]="12"
        [readonly]="isValid$ | async"
        [title]="(isValid$ | async) ? ('offer.discount.valid-label' | translate) : ('offer.discount.label' | translate)"
      />
    </nx-formfield>
    <div class="promo-form-wrapper">
      <button
        *ngIf="!(isValid$ | async)"
        nxButton="secondary promo-button"
        type="submit"
        (click)="handleSubmit()"
        class="submit-button nx-margin-bottom-m"
      >
        {{ 'offer.discount.btn' | translate }}
      </button>
      <button *ngIf="isValid$ | async" nxButton="secondary promo-button" (click)="removeDiscountCode()" class="nx-margin-bottom-m">
        {{ 'offer.discount.btn-remove' | translate }}
      </button>
    </div>
  </form>
  <ng-container [ngSwitch]="state$ | async">
    <div *ngSwitchCase="apiState.success" class="promo-status" [ngClass]="(isValid$ | async) ? 'valid' : 'invalid'">
      <nx-icon [name]="(isValid$ | async) ? 'check-circle' : 'exclamation-circle'" size="s" class="nx-margin-right-xs"></nx-icon>
      <p nxCopytext="normal">
        <b>
          {{ ((isValid$ | async) ? 'offer.discount.success' : 'offer.discount.error') | translate }}
        </b>
      </p>
    </div>
    <ng-container *ngSwitchCase="apiState.error">
      <app-error *ngIf="(error$ | async)?.code !== 429" [appError]="error$ | async" />
      <nx-message *ngIf="(error$ | async)?.code === 429" context="error">
        {{ 'offer.discount.error-too-many-requests' | translate }}
      </nx-message>
    </ng-container>
  </ng-container>
</div>
